export const getApiData = async (url: string) => {
    try{
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            return { data, error: null };
    }catch (error) {
        console.error('Uncaught Error:', error);
        return { data: null, error };
    }
};
